module.exports = __webpack_public_path__ + "static/media/Taha.8ff5c4ae.JPG";